import getRequest from '../../../../../getRequest';

/**
 * Get the Transaction Types mapping for bulk operations.
 *
 * @returns Types mapping
 */
export default function getTransactionTypes() {
  const endpoint = '/oc-product-bulkapi/v1/bulk-process/reports/transaction-types';

  return new Promise((resolve, reject) => {
    getRequest(endpoint, 'Get Transaction Types')
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}
